import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateSpinWheelUserEntity } from '../../domain/entities/UpdateSpinWheelUserEntity'

export class UpdateSpinWheelUserModel extends UpdateSpinWheelUserEntity {
  userIds?: string[]
  constructor(dataDto: UpdateSpinWheelUserEntity) {
    super()
    mapEntityProperties<UpdateSpinWheelUserModel>(this, dataDto, {
      exclude: ['users'],
      map: {
        userIds: dataDto.users?.map((user) => user.id)
      }
    })
  }
}
